import request from '@/utils/request'

// 获得im人员分页列表(列表用)
export function getOnlineService(query) {
    return request({
      url: '/com/shop/im/pageMember',
      method: 'get',
      params: query
    })
  }

// 获取聊天列表（im用）
export function getOnlineServicePage(query) {
  return request({
    url: '/com/shop/im/listMember',
    method: 'get',
    params: query
  })
}
  
  // 查询历史消息
  export function queryHistoryListApi(query) {
    return request({
      url: '/com/shop/im/page',
      method: 'get',
      params: query
    })
  }
  // 发送消息
  export function sendMessageApi(data) {
    return request({
      url: '/com/shop/im/sendMessage',
      method: 'post',
      data
    })
  }
  
  